/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Sources/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import Loading from './Loading/index'
import No from './No/index'
import None from './None/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Sources({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/ImportFromDevices/Content/ModalBody/Sources"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let dwtValueData = fromData.useDataFormat({ viewPath,
context: 'dwt',
format: fromHelpers.view,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: dwtValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'None'}>
<None
  viewPath={`${viewPath}/None`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Loading'}>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}